import { Link } from "react-router-dom";
import { useInView } from "../../../hooks/useInView";

export default function CtaSection() {
  const { ref, inView } = useInView(0.1);

  return (
    <section className="relative w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://framerusercontent.com/images/G7vOiWCtilCao3EPm8ioIuenxg.png"
          alt="PWA Event"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/70" />
        {/* Diagonal stripe overlay */}
        <div className="absolute inset-0 bg-diagonal-stripe-dark pointer-events-none opacity-60" />
      </div>

      {/* Orange glow accent */}
      <div className="absolute bottom-0 left-1/4 w-96 h-48 bg-orange-500/15 blur-3xl pointer-events-none animate-glow-pulse" />

      {/* Content */}
      <div
        ref={ref as React.RefObject<HTMLElement>}
        className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32"
      >
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            {/* Orange accent line */}
            <div className={`flex items-center gap-3 mb-5 anim-hidden ${inView ? "animate-fade-in-left" : ""}`}>
              <div className={`h-0.5 bg-orange-500 w-8 anim-hidden ${inView ? "line-grow delay-100" : ""}`} />
              <span className="text-orange-400 font-condensed text-xs uppercase tracking-widest">
                Pacific Wrestling Alliance
              </span>
            </div>

            <h2
              className={`font-condensed font-black text-white uppercase leading-none tracking-tight mb-4 anim-hidden ${inView ? "animate-fade-in-left delay-100" : ""}`}
            >
              <span className="block text-5xl md:text-6xl lg:text-7xl">Witness History</span>
              <span className="block text-5xl md:text-6xl lg:text-7xl text-shimmer">First Hand</span>
            </h2>

            <p
              className={`text-zinc-300 text-sm max-w-sm anim-hidden ${inView ? "animate-fade-in-up delay-300" : ""}`}
            >
              Click the link for more info on our next event
            </p>
          </div>

          <div
            className={`flex flex-col sm:flex-row items-start sm:items-center gap-5 anim-hidden ${inView ? "animate-fade-in-right delay-200" : ""}`}
          >
            <Link
              to="/events"
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-condensed font-bold text-sm uppercase tracking-widest px-8 py-4 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              Next Event
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
            <div className="flex items-center gap-2 text-zinc-300">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-orange-400" />
              </div>
              <span className="font-condensed text-sm uppercase tracking-wide whitespace-nowrap">
                Located in Stanton, CA
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
